import AppModal from '../../ui-components/AppModal';

import { DynamicDropdownModalProps } from './model';

const DynamicDropdownModal = ({
  isOpen,
  title,
  value,
  options,
  onChange,
  onSubmit,
  onClose,
  cancelText = 'Cancel',
  updateText = 'Update',
}: Readonly<DynamicDropdownModalProps>) => {
  if (!isOpen) {
    return null;
  }

  return (
    <AppModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      formId="setting-form"
      actions={[
        {
          label: updateText,
          type: 'submit',
          variant: 'primary',
        },
        {
          label: cancelText,
          type: 'button',
          variant: 'secondary',
          onClick: onClose,
        },
      ]}
    >
      <form
        id="setting-form"
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
        className="space-y-4"
      >
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {value.description}
        </label>

        {options.length > 1 ? (
          <select
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-500"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            autoFocus
          >
            {options.map((opt) => (
              <option key={`${opt.value}-${opt.name}`} value={opt.value}>
                {opt.name}
              </option>
            ))}
          </select>
        ) : (
          <input
            type="text"
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-500"
            value={options[0].value}
            onChange={(e) => onChange(e.target.value)}
            autoFocus
          />
        )}
      </form>
    </AppModal>
  );
};

export default DynamicDropdownModal;
